export class SurveyAnswerItemContentText {
  value: string | null = null;

  constructor(init?: Partial<SurveyAnswerItemContentText>) {
    Object.assign(this, init);
  }
}
